import { auth } from '../firebase/config';
import { activityApi } from '../firebase/functionsService';
import { deviceLabel } from './deviceLabel';

const ACTIVE_ROLE_KEY = 'tippi_activeRole'; // samme nøkkel som AuthContext
const MAX_ERRORS_PER_SESSION = 10;
const DEDUPE_MS = 60 * 1000;

let errorCount = 0;
const lastSeen = new Map();

export function _resetActivityClientForTests() {
  errorCount = 0;
  lastSeen.clear();
}

function activeRole() {
  try { return localStorage.getItem(ACTIVE_ROLE_KEY); } catch { return null; }
}

// Sender en hendelse til aktivitetsloggen. Feiler stille: logging skal aldri forstyrre appen.
export async function logActivityEvent(type, { summary }) {
  try {
    if (!auth.currentUser) return;
    if (type === 'clientError') {
      const now = Date.now();
      if (errorCount >= MAX_ERRORS_PER_SESSION) return;
      if (now - (lastSeen.get(summary) ?? 0) < DEDUPE_MS) return;
      lastSeen.set(summary, now);
      errorCount += 1;
    }
    await activityApi.logClientEvent({
      type,
      summary: String(summary).slice(0, 200),
      role: activeRole(),
      page: typeof window !== 'undefined' ? window.location.pathname : null,
      device: deviceLabel(),
    });
  } catch {
    // ignorert
  }
}

// Fanger uhåndterte feil i nettleseren. Returnerer en funksjon som fjerner lytterne.
export function installErrorLogging() {
  const onError = (e) => logActivityEvent('clientError', { summary: e.message || String(e.error ?? 'Ukjent feil') });
  const onRejection = (e) => logActivityEvent('clientError', {
    summary: `Ubehandlet avvisning: ${e.reason?.message ?? String(e.reason ?? 'ukjent')}`,
  });
  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);
  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
}
